import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'
import { parseISO, formatDistanceToNow } from 'date-fns'
//import Input from '../../components/abstractObjects/Input';
import { Grid, Button, Hidden, makeStyles } from '@material-ui/core'
import * as Constants from '../constants'
import VAR_A from '../../images/VAR-A.png'
//import VAR_F from '../../images/VAR-F.png'
import VAR_R from '../../images/VAR-R.png'
//import VAR_S from '../../images/VAR-S.png'
//import VAR_U from '../../images/VAR-U.png'
import VAR_C from '../../images/VAR-C.png'
import VAR_PO from '../../images/VAR-PO.png'
import VAR_PY from '../../images/VAR-PY.png'
import { BasicLabel } from '../../components/abstractObjects/Label'
import { Translation } from '../translations/getTranslation'

import {
    fetchActiveVarsList,
    selectActiveVarById,
    selectActiveVarIds
} from './activeVarsListSlice'

const elementStyle = makeStyles({
    root: {
        width: "100%",
        cursor: "pointer",
        padding: 6.5,
        border: "1.5px solid #ddd",
        borderRadius: 3
    },
    text: {
        color: "#000",
        fontWeight: 400,
        textAlign: "center"
    }
})

const CalculateOverdue = (overdueDate) => {
    if (overdueDate === "" || overdueDate === null || overdueDate === undefined) return "Err"

    var dayToBeAdded = 0
    overdueDate.setHours(23)
    overdueDate.setMinutes(59)
    overdueDate.setSeconds(59)

    // Controllo se non abbiamo giorni lavorativi in cui scatta l'overdue o che cadono in giorni non lavorativi
    if (overdueDate.getDay() === 0)
        dayToBeAdded++
    else if (overdueDate.getDay() === 3 || overdueDate.getDay() === 4 || overdueDate.getDay() === 5 || overdueDate.getDay() === 6)
        dayToBeAdded += 2

    // Aggiungo il periodo massimo per prendere in carico una VAR
    dayToBeAdded += 3
    overdueDate = new Date(overdueDate.getTime() + dayToBeAdded * 36e5 * 24)

    var now = new Date()
    if (overdueDate >= now) return ""

    overdueDate.setHours(now.getHours())
    overdueDate.setMinutes(now.getMinutes())
    overdueDate.setSeconds(now.getSeconds())

    var overdueTime = formatDistanceToNow(overdueDate).split(" ").map((piece) => Translation.t(piece.toUpperCase())).join(" ");
    return "- " + overdueTime + " " + Translation.t("OVERDUE")
}

let VarExcerpt = ({ varId }) => {
    const elementStyles = elementStyle()
    const varx = useSelector((state) => selectActiveVarById(state, varId))
    if (varId === null) return ""
    var overdueDate = parseISO(varx.EstimatedDateOfArrival)
    const timePeriod = CalculateOverdue(overdueDate)

    let color = null
    switch (varx.StatusId) {
        case Constants.VAR_STATUS_CANCELLED:
            color = VAR_C //Constants.VAR_STATUS_COLOR_CANCELLED
            break
        case Constants.VAR_STATUS_APPROVED:
            color = VAR_PO //Constants.VAR_STATUS_COLOR_APPROVED
            break
        case Constants.VAR_STATUS_UPLOADED:
            color = VAR_PY //Constants.VAR_STATUS_COLOR_UPLOADED
            break
        case Constants.VAR_STATUS_SUBMITTED:
            color = VAR_PY //Constants.VAR_STATUS_COLOR_SUBMITTED
            break
        case Constants.VAR_STATUS_REFERBACKSD:
            color = VAR_R //Constants.VAR_STATUS_COLOR_REFERBACKSD
            break
        case Constants.VAR_STATUS_FINALISED:
            color = VAR_A //Constants.VAR_STATUS_COLOR_FINALISED
            break
        default:
            color = VAR_R //Constants.VAR_STATUS_COLOR_UNAPPROVED
    }

    return (
        <Grid container key={varx.Id} justifyContent="center" style={{ marginBottom: "1rem" }}>
            <Grid item xs={2}>
                {varx.StatusId > Constants.VAR_STATUS_UPLOADED ? 
                    <Button style={{ minWidth: 40, width: "calc(5px + 50%)" }} title={Translation.t("DOWNLOAD_PDF")} size="large" variant="outlined" onClick={() => window.open(`/VarTransactions/DownloadFinalisedPdf?VarTransactionId=${varx.Id}`)}>
                        <span className="fas fa-file-alt" />
                    </Button> : '' }
            </Grid>
            <Grid item className={elementStyles.root} xs={10}>
                <Link to={`/active/${varx.Id}`} style={{ width: "100%", textDecoration: "none" }}>
                    <Grid container>
                        <Grid container item xs={2} sm={1} justifyContent="center" alignItems="center">
                            <img style={{ marginLeft: 12, width: 55, height: 50 }} className="varStatusCircle" src={color} alt="var" />
                        </Grid>
                        <Grid item xs={10} sm={6} className={elementStyles.text}>
                            <h4 style={{ margin: 0 }}>{varx.ReportNo}</h4>
                            <Hidden smUp>AWB n. {varx.Awbno}<br /></Hidden>
                                PO n. {varx.Pono} {timePeriod}
                        </Grid>
                        <Hidden xsDown>
                            <Grid item sm={5} className={elementStyles.text}>
                                <h4>AWB n. {varx.Awbno}</h4>
                                <div style={{ textAlign: 'center', fontWeight: '500' }}>ETA {varx.EstimatedDateOfArrival.substring(0, 10).split("-").reverse().join("/")}</div>
                            </Grid>
                        </Hidden>
                    </Grid>
                </Link>
            </Grid>
        </Grid>
    )
}

export const ActiveVarsList = () => {
    const dispatch = useDispatch()
    const orderedVarIds = useSelector(selectActiveVarIds)

    const varStatus = useSelector((state) => state.activeVars.status)
    const error = useSelector((state) => state.activeVars.error)
    //const [months, setMonths] = useState(1)

    //const OnMonthsChanged = (e) => {
    //    setMonths(e.target.value)
    //    dispatch(Reload())
    //}

    useEffect(() => {
        if (varStatus === 'idle')
            dispatch(fetchActiveVarsList())
    }, [varStatus, dispatch])

    let content
    if (varStatus === 'loading') {
        content = <div className="loader"></div>
    } else if (varStatus === 'succeeded') {
        content = orderedVarIds.map((varId) => (
            <VarExcerpt key={varId} varId={varId} />
        ))
    } else if (varStatus === 'error') {
        content = <div>{error}</div>
    }

    //var optionsMonths = [{ Name: "ALL", Id: 99 }, { Name: "1_MONTH", Id: 1 }, { Name: "3_MONTH", Id: 3 }, { Name: "6_MONTH", Id: 6 }]
    return (
        <section className="var-list">
            <br />
            <Grid container align="center">
                <Grid item xs={12}><h2><BasicLabel text="ACTIVE_VARS" /></h2></Grid>
                {/*<Grid item xs={12} md={6}><h2><BasicLabel text="ACTIVE_VARS" /></h2></Grid>*/}
                {/*<Grid item xs={8} md={4}><Input type="select" size="small" variant="outlined" value={months} selectOptions={optionsMonths} onChange={OnMonthsChanged} /></Grid>*/}
                {/*<Grid item xs={4} md={2}><Button variant="outlined" onClick={() => dispatch(Reload())}><i className="fas fa-sync-alt" /></Button></Grid>*/}
                {/*<Grid item xs={6} md={6} style={{ marginTop: "8px" }}><Button variant="outlined" onClick={() => window.open(`/VarTransactions/DownloadExcel?takeMonths=${months}&type=pivot`)}><i className="fas fa-file-excel" />&nbsp;<BasicLabel text="DETAILED_EXCEL" /></Button></Grid>*/}
                {/*<Grid item xs={6} md={6} style={{ marginTop: "8px" }}><Button variant="outlined" onClick={() => window.open(`/VarTransactions/DownloadExcel?takeMonths=${months}`)}><i className="fas fa-file-excel" />&nbsp;<BasicLabel text="EXCEL" /></Button></Grid>*/}
            </Grid>
            <br />
            {content}
        </section>
    )
}